import callAPI from '../ApiConfig'

const settings = async (props) => {


    return await callAPI({
        route: "setting/public",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }

    })

}
const updateSettings = async (props) => {

    return await callAPI({
        route: "setting/public",
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
            ...props?.headers
        }
    })
}
const tagAPI = {
    settings: settings,
    updateSettings: updateSettings
}
export default tagAPI